import React from 'react';
import { Flex } from '@adobe/react-spectrum';
import DeleteOutline from '@spectrum-icons/workflow/DeleteOutline';
import LayersBackward from '@spectrum-icons/workflow/LayersBackward';
import LayersForward from '@spectrum-icons/workflow/LayersForward';
import PinOff from '@spectrum-icons/workflow/PinOff';
import PinOn from '@spectrum-icons/workflow/PinOn';
import { getMarkerLayer, getMarkersInLayer, } from 'app/core/markers/models';
import { ProjectActions } from 'app/stores/project/actions';
import { getSelection, getSelectionAlias, hasSelectedLockedItems, } from 'app/stores/selectors';
import { useAppDispatch } from 'app/stores/store';
import { Button } from 'app/views/components/editor/sidebar/Button';
import { Divider } from 'app/views/components/editor/sidebar/Divider';
import { ArrowPicker } from 'app/views/components/editor/sidebar/tools/ArrowTypePicker';
import { BlurPicker } from 'app/views/components/editor/sidebar/tools/BlurMethodPicker';
import { FontPicker } from 'app/views/components/editor/sidebar/tools/FontPicker';
import { SpotPicker } from 'app/views/components/editor/sidebar/tools/SpotTypePicker';
import { useConnect } from 'app/views/hooks/useConnect';
import { ImagePicker } from './tools/ImagePicker';
import { ZoomPicker } from './tools/ZoomTypePicker';
const MarkerTools = {
    Text: FontPicker,
    Spot: SpotPicker,
    Arrow: ArrowPicker,
    Blur: BlurPicker,
    Zoom: ZoomPicker,
    Image: ImagePicker,
};
const Reorder = () => {
    const dispatch = useAppDispatch();
    const onMoveUp = React.useCallback(() => {
        dispatch(ProjectActions.itemReorder({ direction: 'up' }));
    }, [dispatch]);
    const onMoveDown = React.useCallback(() => {
        dispatch(ProjectActions.itemReorder({ direction: 'down' }));
    }, [dispatch]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { "data-test-id": "lock", label: "Move up", Icon: LayersForward, onPress: onMoveUp }),
        React.createElement(Button, { "data-test-id": "lock", label: "Move down", Icon: LayersBackward, onPress: onMoveDown })));
};
export const Selection = (props) => {
    const { direction = 'column' } = props;
    const dispatch = useAppDispatch();
    const stateProps = useConnect(state => {
        const markers = getSelection(state);
        const alias = getSelectionAlias(state);
        const selectionIsLocked = markers.length > 0 ? hasSelectedLockedItems(state) : false;
        return { markers, alias, selectionIsLocked };
    });
    const { markers, alias, selectionIsLocked } = stateProps;
    const hasSelection = markers.length > 0;
    const onDelete = React.useCallback(() => {
        dispatch(ProjectActions.deleteItems({
            ids: markers,
        }));
    }, [dispatch, markers]);
    const onLock = React.useCallback(() => {
        dispatch(ProjectActions.itemsUpdate({
            patches: markers.reduce((accum, id) => {
                accum[id] = { locked: !selectionIsLocked };
                return accum;
            }, {}),
        }));
    }, [dispatch, markers, selectionIsLocked]);
    if (!hasSelection) {
        return null;
    }
    const canReorder = getMarkersInLayer(getMarkerLayer(alias)) > 1;
    const PinIcon = selectionIsLocked ? PinOn : PinOff;
    const Component = MarkerTools[alias];
    return (React.createElement(React.Fragment, null,
        React.createElement(Divider, null),
        React.createElement(Flex, { direction: direction },
            Component && React.createElement(Component, null),
            canReorder && React.createElement(Reorder, null),
            React.createElement(Button, { "data-test-id": "lock", label: "Lock", Icon: PinIcon, onPress: onLock }),
            React.createElement(Button, { "data-test-id": "delete", label: "Delete", Icon: DeleteOutline, onPress: onDelete }))));
};
